import axios from 'axios';
import { getFilenameFromContentDisposition } from '@/api/attachmentsApi.js';

const getNameFromUrl = url => url.slice(url.lastIndexOf('/') + 1, url.lastIndexOf('.'));

/**
 * @param {string} url
 * @param {string} [fileName]
 * @returns {Promise<File>}
 */
export const getImageFileFromUrl = async (url, fileName = getNameFromUrl(url)) => {
    const response = await axios.get(url, { responseType: 'blob' });
    /**
     * @type {Blob}
     */
    const blob = response.data;

    return new File(
        [blob],
        fileName || getFilenameFromContentDisposition(response.headers['content-disposition']),
        { type: blob.type || response.headers['content-type'] },
    );
};

export default getImageFileFromUrl;
